//export const HOST = 'http://service.releasepilot.com';
export const HOST = (process.env.NODE_ENV==='production')?'http://service.whatzneu.com':'http://localhost';
export const LEAD_SERVICE_PORT = 1996;
export const AUTH_SERVICE_PORT = 8081;
export const ARTIFICAL_ASSISTANCE_SERVICE_PORT = 8085;

export const LEAD_SERVICE_HOST = (process.env.NODE_ENV==='production')?`${HOST}`:`${HOST}:${LEAD_SERVICE_PORT}`;
export const AUTH_SERVICE_HOST = (process.env.NODE_ENV==='production')?`${HOST}`:`${HOST}:${AUTH_SERVICE_PORT}`;
export const ARTIFICAL_ASSISTANCE_SERVICE_HOST = (process.env.NODE_ENV==='production')?`${HOST}`:`${HOST}:${ARTIFICAL_ASSISTANCE_SERVICE_PORT}`;
export const AUTH_API_PREFIX = '/auth/v1';
export const LEAD_API_PREFIX = '/api/v1';
export const ARTIFICAL_ASSISTANCE_API_PREFIX = '/artificial-assistance/v1';
